import * as bootstrap from 'bootstrap';
import Mustache from 'mustache';
import template from '../../mustache/bootstrap-modal.js';

/**
 * Handles the click event for links with the class 'itemLink'.
 * Ensures the DOM is fully loaded before attaching event listeners.
 */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a.itemLink').forEach(function(link) {
        link.addEventListener('click', onItemClicked.bind(this, link));
    });
});

/**
 * Handles the click event for a specific link.
 * Dynamically loads content into a Bootstrap modal and displays it.
 *
 * @param {Event} event - The click event object.
 * @param {HTMLElement} link - The clicked link element.
 */
async function onItemClicked(link, event) {

    if (link.classList.contains('file')) {
        return;
    }

    event.preventDefault();

    var elemHref = link.getAttribute('href');
    var ajaxurl = link.dataset.ajaxurl;

    if (ajaxurl) {
        
        try {
            const response = await fetch(elemHref);

            if( response.ok ) {
                const contentHTML = await response.text(); // Assuming the server returns JSON data

                const rendered = Mustache.render(template, {
                    modalTitle: '',
                    modalBody: contentHTML,
                    closeButtonText: 'Sulje',
                    saveButtonText: 'Tallenna'
                });

                document.body.insertAdjacentHTML('beforeend', rendered);

                const modalElement = document.getElementById('bootstrapModal');

                const modalBodyContainer = modalElement.querySelector('.modal-body .container');

                modalElement.querySelector('.modal-title').innerHTML = `
                <span>${modalBodyContainer.dataset.title}</span>
                <img src="${modalBodyContainer.dataset.availability}" style="max-height: 20px;" alt="">
                `;

                modalElement.addEventListener('hidden.bs.modal', () => {
                    modalElement.remove();
                });

                const bootstrapModal = new bootstrap.Modal(modalElement);

                bootstrapModal.show();
            } else {
                console.log('Product was not found');
            }
        } catch (error) {
            console.error('Error loading modal content:', error);
        }
    }
}
